// Generated by portal/sdk/scripts/build.js.
module.exports = "/vitals/milla-vitals.42fa59213abb.js";
